import { ProductInfo } from "../../api/generated/models/ProductInfo";

export interface ModelMetadata {
    [key: string]: {
        [key: string]: any;
    };
}

export default interface MetadataState {
    metadata: {
        [key: string]: ModelMetadata;
    };
    productInfo: ProductInfoMap;
    productIds: ProductIdMap;
}

export class ProductInfoMap {
    private productInfo: { [key: number]: ProductInfo } = {};

    constructor(productInfo: ProductInfo[]) {
        productInfo.forEach(info => {
            this.productInfo[info.id] = info;
        });
    }

    get(productId: number | undefined | null): ProductInfo | null {
        return (productId && this.productInfo[productId]) || null;
    }
}

export type ProductIdMap = {
    [key: string]: number;
};
